import request from '@/utils/request'

export function selectSpecialSet(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/specialSet/selectSpecialSet?access=${data}`,
        method: 'post',
       // data,
    })
}

export function addSpecialSet(data) {
    return request({
        url: `api/serviceCenter/specialSet/addSpecialSet`,
        method: 'post',
        data,
    })
}

